module.exports = __webpack_public_path__ + "media/images/icon__arrow-right@2x-993e130d435a79eb24f60c0c8d51f64a.png";